// extracted by mini-css-extract-plugin
export default {"wrapper":"NoteTitle_wrapper__DHFEo","textarea":"NoteTitle_textarea__VsrzX"};